<ng-container *ngIf="mask.length>0">
  <span class="cb-icon" [style.-webkit-mask-image]="mask"></span>
</ng-container>
